import { calculateTimeDifferenceInPercentage, ncFileStatuses, withERP } from '@helpers';
import { TILE_CONFIG } from '@v2/pages/common/constants/base.constants';

/**
 * Calculates image dimensions based on display mode and item size
 */
export const getImageSize = (isLineMode: boolean, itemSize: number, scale: (v: number) => number) => {
  if (isLineMode) {
    return { width: scale(TILE_CONFIG.LINE_MODE_WIDTH), height: scale(TILE_CONFIG.LINE_MODE_HEIGHT) };
  }
  const width = TILE_CONFIG.BASE_WIDTH;
  const height = TILE_CONFIG.BASE_HEIGHT;
  const prop = itemSize / width;
  const newHeight = height * prop;
  return { width: itemSize - 2, height: newHeight };
};

/**
 * Determines whether v1 < v2 (both non-null) for showing minus indicator
 */
export const shouldDisplayMinus = (v1: number | null | undefined, v2: number | null | undefined): boolean => {
  return v1 != null && v2 != null && v1 < v2;
};

/**
 * Computes visibility and percentage values for ideal/paid time indicators
 */
export const computeTimeIndicators = ({
  item,
  batchStatistics,
  isWithERP,
}: {
  item: any;
  batchStatistics: any;
  isWithERP: boolean | null;
}) => {
  const actualTime = !item?.isInProgress ? item?.actualTotalTimeTotalInSeconds : batchStatistics?.actualTotalTimeTotalInSeconds;
  const idealTime = !item?.isInProgress ? item?.idealTotalTimeTotalInSeconds : batchStatistics?.idealTotalTimeTotalInSeconds;
  const paidTime = batchStatistics?.paidTotalTimeTotalInSeconds;

  const computedIdealTimePercentage = calculateTimeDifferenceInPercentage(idealTime, actualTime);
  const computedPaidTimePercentage = calculateTimeDifferenceInPercentage(paidTime, actualTime);

  const shouldHideIdeal = idealTime === 0 || actualTime === 0 || computedIdealTimePercentage === '0%';

  const shouldHidePaid =
    paidTime === 0 ||
    actualTime === 0 ||
    computedPaidTimePercentage === '0%' ||
    (!item.links?.length &&
      ([ncFileStatuses.Unknown, ncFileStatuses.Ignored].includes(item.ncFileStatus) || (ncFileStatuses.Linked && withERP(isWithERP))));

  const shouldDisplayMinusForIdeal = shouldDisplayMinus(idealTime, actualTime);
  const shouldDisplayMinusForPaid = shouldDisplayMinus(paidTime, actualTime);

  return {
    actualTime,
    idealTime,
    paidTime,
    computedIdealTimePercentage,
    computedPaidTimePercentage,
    shouldHideIdeal,
    shouldHidePaid,
    shouldDisplayMinusForIdeal,
    shouldDisplayMinusForPaid,
  };
};
